import React from "react";
import Banner from "./HomeBanner";
import IntrestedForm from "./IntrestedForm";
import ProgrameAdvisor from "./ProgramAdvisor";

function BecomeOnInstructor() {
  return (
    <div >
        {/* <Banner /> */}
        <IntrestedForm />
        <ProgrameAdvisor />
    </div>
  );
}

export default BecomeOnInstructor;